import { createContext, useContext } from 'react';

export interface MonitorContextType {
    monitorId?: number;
    conditionRootId?: string;
    setConditionRootId?: (id: string) => void;
}

export const MonitorContext = createContext<MonitorContextType>({});

export const useMonitorContext = () => useContext(MonitorContext);
